import { AbstractControl, ValidatorFn, FormGroup } from "@angular/forms";
import { MedicalOrderEdit } from "../model/medical-order-edit";
import { Entity } from "../model/entity";
import { MedicalOrderEditInfo } from "../model/medical-order-edit-info";
import {
  setInValidControl,
  setValidControl,
} from "./validaror-invalid-control";

export function validateMedicalOrderEdit(control: AbstractControl) {
  if (
    !control.value ||
    control.value === "" ||
    typeof control.value === "string"
  ) {
    return { validMedicalOrderEdit: true };
  }

  const medicalOrderEdit = <MedicalOrderEdit>control.value;

  if (
    medicalOrderEdit.MedicalOrderEditInfo &&
    medicalOrderEdit.MedicalOrderEditInfo.CredentialNumberValidate &&
    !medicalOrderEdit.MedicalOrder.CredentialNumber
  ) {
    return {
      validMedicalOrderEdit: true,
      medicalOrderEditErrorDescription: "No ha ingresado el número de afiliado",
    };
  }
  if (
    medicalOrderEdit.MedicalOrderEditInfo.CanViewReferringPhysician &&
    !medicalOrderEdit.MedicalOrder.ReferringPhysicianId
  ) {
    return {
      validMedicalOrderEdit: true,
      medicalOrderEditErrorDescription: "No ha ingresado el médico solicitante",
    };
  }

  return null;
}

export function medicalOrderDateValidator(control: FormGroup) {
  if (control.value) {
    let isValidDate = true;
    let prescriptionDate: AbstractControl = null;
    const medicalOrderEditInfo = <MedicalOrderEditInfo>(
      control.get("MedicalOrderEditInfo").value
    );

    if (medicalOrderEditInfo && medicalOrderEditInfo.CanViewMedicaOrderDate) {
      const medicalOrder = (<FormGroup>this.form.get("MedicalOrder")).controls;
      prescriptionDate = medicalOrder.PrescriptionDate;

      if (
        prescriptionDate.value &&
        (medicalOrderEditInfo.AthorizationValidity ||
          medicalOrderEditInfo.MedicalOrderValidity)
      ) {
        const validityDay = medicalOrderEditInfo.AthorizationValidity
          ? medicalOrderEditInfo.AthorizationValidityDay
          : medicalOrderEditInfo.MedicalOrderValidityDay;
        isValidDate = isValidMedicalOrderDate(
          prescriptionDate.value,
          validityDay
        );
      }
    }

    if (isValidDate) {
      if (
        prescriptionDate &&
        prescriptionDate.errors &&
        !prescriptionDate.errors.required
      ) {
        setValidControl(prescriptionDate);
        return null;
      }
    } else {
      setInValidControl(prescriptionDate);
      return { invalidAthorizationValidity: true };
    }
  }
}

export function medicalOrderCredentialNumberValidator(control: FormGroup) {
  if (control.value) {
    let isValidCredentialNumber = true;
    let credentialNumber: AbstractControl = null;
    const medicalOrderEditInfo = <MedicalOrderEditInfo>(
      control.get("MedicalOrderEditInfo").value
    );

    if (medicalOrderEditInfo) {
      const medicalOrder = (<FormGroup>this.form.get("MedicalOrder")).controls;
      credentialNumber = medicalOrder.CredentialNumber;

      if (
        (!credentialNumber.value || credentialNumber.value === "") &&
        medicalOrderEditInfo.CredentialNumberValidate
      ) {
        isValidCredentialNumber = false;
      }
    }

    if (isValidCredentialNumber) {
      setValidControl(credentialNumber);
    }

    if (!isValidCredentialNumber) {
      setInValidControl(credentialNumber);
    }

    if (isValidCredentialNumber) {
      return null;
    } else {
      return { invalidCredentialNumber: true };
    }
  }
}

export function medicalOrderDiagnosticValidator(control: FormGroup) {
  if (control.value) {
    let isValidDiagnostic = true;
    let diagnostic: AbstractControl = null;
    const medicalOrderEditInfo = <MedicalOrderEditInfo>(
      control.get("MedicalOrderEditInfo").value
    );

    if (medicalOrderEditInfo) {
      const medicalOrder = (<FormGroup>this.form.get("MedicalOrder")).controls;
      diagnostic = medicalOrder.Diagnostic;

      if (
        (!diagnostic.value || diagnostic.value === "") &&
        medicalOrderEditInfo.DiagnosticRequired &&
        !medicalOrderEditInfo.DiagnosticCIERequired
      ) {
        isValidDiagnostic = false;
      }
    }

    if (isValidDiagnostic) {
      setValidControl(diagnostic);
    }

    if (!isValidDiagnostic) {
      setInValidControl(diagnostic);
    }

    if (isValidDiagnostic) {
      return null;
    } else {
      return { invalidDiagnostic: true };
    }
  }
}

export function medicalOrderDiagnosisCIEValidator(control: FormGroup) {
  if (control.value) {
    let isValidDiagnosisCIE = true;
    let diagnostic: AbstractControl = null;
    const medicalOrderEditInfo = <MedicalOrderEditInfo>(
      control.get("MedicalOrderEditInfo").value
    );

    if (medicalOrderEditInfo) {
      const medicalOrder = (<FormGroup>this.form.get("MedicalOrder")).controls;
      diagnostic = medicalOrder.DiagnosisCIE;

      if (
         medicalOrderEditInfo.DiagnosticCIERequired &&
         !diagnostic.value || diagnostic.value === '' || typeof diagnostic.value === 'string'
      ) {
        isValidDiagnosisCIE = false;
      }
    }

    if (isValidDiagnosisCIE) {
      setValidControl(diagnostic);
    }

    if (!isValidDiagnosisCIE) {
      setInValidControl(diagnostic);
    }

    if (isValidDiagnosisCIE) {
      return null;
    } else {
      return { isValidDiagnosisCIE: true };
    }
  }
}

export function isValidMedicalOrderDate(
  value: Date,
  validityDay: number
): boolean {
  const orderDate = new Date(value);
  orderDate.setHours(0, 0, 0, 0);
  orderDate.setDate(orderDate.getDate() + validityDay);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return orderDate >= today;
}
